import apiClient from './apiClient';
import type { Occupation } from './occupationService';
import type { IdDoBanco } from './efetivosService';

/**
 * O que a lista e a ficha do cargo leem do servidor (#606): o cargo com setor e empresa, e a
 * contagem de riscos de vários cargos numa chamada só (E2).
 */

export interface ContagemDeRiscos {
  /** Os riscos que valem para o cargo, sem contar duas vezes o que o cargo substitui. */
  total: number;
  proprios: number;
  herdados: number;
}

/** Por id do cargo, em texto — é como o servidor devolve a chave. */
export type ContagemPorCargo = Record<string, ContagemDeRiscos>;

export async function buscarCargoComSetorEEmpresa(id: IdDoBanco): Promise<Occupation> {
  const resposta = await apiClient.get<Occupation>(
    `/occupations/${encodeURIComponent(String(id))}?include=relations`
  );
  if (!resposta.data) throw new Error('Cargo não encontrado.');
  return resposta.data;
}

/** Uma chamada por página da lista, nunca uma por linha. */
export async function contarRiscosDosCargos(ids: IdDoBanco[]): Promise<ContagemPorCargo> {
  if (ids.length === 0) return {};
  const parametros = new URLSearchParams({ nivel: 'occupation', ids: ids.map(String).join(',') });
  const resposta = await apiClient.get<ContagemPorCargo>(`/risk-applications/contagem?${parametros.toString()}`);
  return resposta.data ?? {};
}
